"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.LayoutComponent = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _jsxFileName = "/Users/newuser/Documents/GitHub/gatsby-plugin-transition-link/src/components/Layout.js";

var React = require("react");

var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

var Layout = false;

if (typeof GATSBY_LAYOUT_COMPONENT_PATH !== "undefined" && !!GATSBY_LAYOUT_COMPONENT_PATH) {
  try {
    Layout = preferDefault(require(GATSBY_LAYOUT_COMPONENT_PATH));
  } catch (e) {
    if (e.toString().indexOf("Error: Cannot find module") !== -1) {
      throw new Error("Couldn't find layout component at \"" + GATSBY_LAYOUT_COMPONENT_PATH + ".\n\n" + "Please create layout component in that location or specify path to layout component in gatsby-config.js");
    } else {
      // Logging the error for debugging older browsers as there is no way
      // to wrap the thrown error in a try/catch.
      console.error(e);
      throw e;
    }
  }
}

var LayoutComponent = function LayoutComponent(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["children"]);

  if (Layout) {
    return React.createElement(Layout, (0, _extends2.default)({}, props, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29
      },
      __self: this
    }), children);
  } else {
    return children;
  }
};

exports.LayoutComponent = LayoutComponent;